import LazyLoad from "vanilla-lazyload";

export default {
  lazyLoad: function () {
    const lazyLoadInstance = new LazyLoad({
      elements_selector: ".lazy"
    });
  }
}
